import React from 'react';
import { useTranslation } from 'react-i18next';

import { X } from 'lucide-react';

import { closeModal } from '@/components/modals/modals.utils';
import { ModalBase } from '@/components/modals/modals-base';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export interface CreateArchiveModalProps {
  title?: string;
  inputLabel?: string;
  onSubmit: (name: string) => void | Promise<void>;
}

export const CreateArchiveModal: React.FC<CreateArchiveModalProps> = ({
  title,
  inputLabel,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [name, setName] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      setLoading(true);
      await onSubmit(name.trim());
      closeModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalBase className="min-w-[360px]">
      <X
        className="absolute right-3 top-3 cursor-pointer text-slate-500 hover:text-slate-700"
        onClick={closeModal}
        aria-label="Close"
      />
      {title ? (
        <h3 className="mb-4 pr-6 text-md">{title}</h3>
      ) : (
        <h3 className="mb-4 pr-6 text-md">{t('create')}</h3>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label={inputLabel || t('acrchive-name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
        <div className="mt-8 grid grid-cols-2 gap-4">
          <Button onClick={closeModal} variant="outline" className="border-red-500 text-red-500">
            {t('cancel')}
          </Button>
          <Button type="submit" disabled={loading || !name.trim()}>
            {t('save')}
          </Button>
        </div>
      </form>
    </ModalBase>
  );
};
